<template>
  <div class="delete-box" v-bind:class="{ haspadding: hasPadding }">
    <div>
      <b-icon-trash class="plus icon" />
    </div>
    <div class="delete-text">Törlés</div>
  </div>
</template>
<script>
import { BIconTrash } from 'bootstrap-vue'
export default {
  components: { BIconTrash },
  props: ['hasPadding'],
  name: 'DeleteField'
}
</script>
<style scoped>
svg {
  display: inline;
  margin-right: 16px;
  color: #ba3b46;
}
.delete-text {
  color: #ba3b46;
  font-size: 16px;
  line-height: 24px;
  display: inline;
}
.delete-box {
  display: flex;
  padding-top: 0px;
}
.delete-box > div > svg {
  width: 22.5px;
  height: 22.5px;
}
.haspadding {
  padding-top: 15px !important;
}
</style>
